import { createSvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default createSvgIcon(
  <g id="Group_1185" data-name="Group 1185" transform="translate(-54.065 -35.685)">
    <circle
      id="Ellipse_120"
      data-name="Ellipse 120"
      cx="10.5"
      cy="10.5"
      r="10.5"
      transform="translate(54.26 35.685)"
      fill={RoutalPalette.statusColors.canceled}
    />
    <g id="noun_User_2221744" transform="translate(192.795 0.531)">
      <g id="Layer_2" data-name="Layer 2" transform="translate(-135.189 38.683)">
        <path
          id="Path_785"
          data-name="Path 785"
          d="M40.875,42.98h1.55a7.155,7.155,0,0,0-.16-1.276,3.975,3.975,0,0,1-1.389,1.276Z"
          transform="translate(-28.114 -28.669)"
          fill={RoutalPalette.neutral00}
        />
        <g id="Group_1186" data-name="Group 1186" transform="translate(0 -1)">
          <circle
            id="Ellipse_126"
            data-name="Ellipse 126"
            cx="2"
            cy="2"
            r="2"
            transform="translate(-0.941 5.721)"
            fill={RoutalPalette.neutral00}
          />
          <circle
            id="Ellipse_127"
            data-name="Ellipse 127"
            cx="2"
            cy="2"
            r="2"
            transform="translate(5.059 5.721)"
            fill={RoutalPalette.neutral00}
          />
          <circle
            id="Ellipse_128"
            data-name="Ellipse 128"
            cx="2"
            cy="2"
            r="2"
            transform="translate(11.059 5.721)"
            fill={RoutalPalette.neutral00}
          />
        </g>
        <g
          id="Ellipse_124"
          data-name="Ellipse 124"
          transform="translate(-3.541 -3.462)"
          fill="none"
          stroke={RoutalPalette.statusColors.canceled}
          strokeWidth="1"
        >
          <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
          <circle cx="10.5" cy="10.5" r="10" fill="none" />
        </g>
        <g id="Group_1169" data-name="Group 1169" transform="translate(6.939 6.908)">
          <g
            id="Ellipse_119"
            data-name="Ellipse 119"
            transform="translate(-1 -1)"
            fill={RoutalPalette.statusColors.canceled}
            stroke={RoutalPalette.neutral00}
            strokeWidth="0.5"
          >
            <circle cx="6.577" cy="6.577" r="6.577" stroke="none" />
            <circle cx="6.577" cy="6.577" r="6.327" fill="none" />
          </g>
          <line
            id="Line_137"
            data-name="Line 137"
            x2="6.923"
            y2="6.923"
            transform="translate(2.121 2.462)"
            fill="none"
            stroke={RoutalPalette.neutral00}
            strokeLinecap="round"
            strokeWidth="1"
          />
          <line
            id="Line_138"
            data-name="Line 138"
            x1="6.923"
            y2="6.923"
            transform="translate(2.121 2.462)"
            fill="none"
            stroke={RoutalPalette.neutral00}
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </g>
  </g>,
  `ClientsMenuIcon`
);
